import React, { useRef, useState } from "react";
import { cognitoUserToken } from "../../helpers/userHelper";
import { ROW_COUNT } from "../../helpers/variableHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { IAddUsuarioExterno, IUsuarioExterno } from "../../entities/IUsuarioExterno";
import { UsuariosExternosServices } from "../../services/UsuariosExternosServices";
import { Offcanvas } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { stringEmpty } from "../../helpers/stringHelper";
const MySwal = withReactContent(Swal);

interface IAgregarUsuarioExternoProps {
  onClose: () => void;
  show: boolean;
  userEdit: IUsuarioExterno | null;
}

const AgregarUsuarioExterno = ({ onClose, show, userEdit }: IAgregarUsuarioExternoProps) => {
  const userInfo = cognitoUserToken();
  const pageSize = ROW_COUNT;
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [isEditPassword, setIsEditPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const totalPagesTable = useRef<number>(0);
  const refTxtNombre = React.createRef<HTMLInputElement>();
  const refTxtContraseña = React.createRef<HTMLInputElement>();
  const refTxtConfirmarContraseña = React.createRef<HTMLInputElement>();
  const refTxtCorreo = React.createRef<HTMLInputElement>();
  const [userActivo, setUserActivo] = useState<boolean | null>(userEdit ? userEdit.ACTIVO : true);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  console.log(listItems);
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let params = {
      PAGINA: 1,
      PAGINADO: pageSize,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      TERM: "",
    };

    let result = await UsuariosExternosServices.getListUsuariosExternos(token, params);
    setListItems(result.data);
    totalPagesTable.current = result.pages;
  }, []);

  const formValidation = (value: IAddUsuarioExterno) => {
    let arrErrors: Array<string> = [];
    let arrErrorsText: Array<string> = [];

    if (!value.DISPLAY_NAME) {
      arrErrors.push("DISPLAY_NAME");
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!value.EMAIL || !emailPattern.test(value.EMAIL)) {
      arrErrors.push("EMAIL");
      arrErrorsText.push("Debe ingresar un correo válido");
    }
    if (value.ACTIVO == null) {
      arrErrors.push("ACTIVO");
    }

    if (value.CONTRASEÑA) {
      const contieneMinuscula = /[a-z]/.test(value.CONTRASEÑA);
      const contieneMayuscula = /[A-Z]/.test(value.CONTRASEÑA);
      const contieneCaracterEspecial = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value.CONTRASEÑA);
      if (!value.CONTRASEÑA || !refTxtConfirmarContraseña.current?.value) {
        arrErrors.push("CONTRASEÑA");
        arrErrors.push("CONFIRMAR_CONTRASEÑA");
      } else if (value.CONTRASEÑA != refTxtConfirmarContraseña.current?.value) {
        arrErrors.push("CONTRASEÑA");
        arrErrorsText.push("Las contraseñas no coinciden");
      } else if (value.CONTRASEÑA.length <= 8) {
        arrErrors.push("CONTRASEÑA");
        arrErrorsText.push("El largo de la contraseña debe ser de al menos 8 caractéres");
      } else if (!contieneMinuscula || !contieneMayuscula || !contieneCaracterEspecial) {
        arrErrorsText.push("La contraseña debe contener al menos una minúscula, una mayúscula y un caracter especial.");
      }
    }

    showError(arrErrorsText);

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const showError = (arrErrorsText: any) => {
    if (arrErrorsText.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Debe considerar lo siguiente:</h3>
            {arrErrorsText.map((e: any) => (
              <p key={e}>{e}</p>
            ))}
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }
  };
  const guardar = async () => {
    let value: IAddUsuarioExterno = {
      ID: userEdit?.ID,
      DISPLAY_NAME: refTxtNombre.current?.value as string,
      CONTRASEÑA: refTxtContraseña.current?.value as string,
      ACTIVO: userActivo as boolean,
      EMAIL: refTxtCorreo.current?.value as string,
      FECHA_CREACION: userEdit?.FECHA_CREACION || new Date(),
      PROVEEDOR: "Imagen",
      EDIT_CONTRASEÑA: userEdit?.ID != null && !stringEmpty(refTxtContraseña.current?.value),
    };

    if (formValidation(value)) {
      setIsLoading(true);
      let result = await UsuariosExternosServices.setUsuarioExterno(token, value);
      if (!result.ok) {
        MySwal.fire({
          html: (
            <div>
              <h3>Debe considerar lo siguiente:</h3>
              <p>{result.msg}</p>
            </div>
          ),
          text: "",
          icon: "error",
          showCloseButton: true,
        });
        setIsLoading(false);
      } else {
        onClose();
      }
    }
  };

  return (
    <Offcanvas show={show} onHide={onClose} placement={"end"} className="w-40 modalAgregarCausa">
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title className="m-3 mb-1 colorTit">{userEdit ? "Editar" : "Agregar"} Usuario</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="m-3">
        <div className="container-fluid mb-4">
          <button
            hidden={true}
            data-testid="btnupload"
            onClick={() => {
              formValidation({ ACTIVO: true, CONTRASEÑA: "sssss", DISPLAY_NAME: "", EDIT_CONTRASEÑA: false, EMAIL: "", FECHA_CREACION: new Date() });
            }}></button>
          <div className="row mb-2 ajusteInput">
            <div className="col-12 mb-2 mt-1">
              <span className="text-danger">
                <strong>(*)</strong>
              </span>
              <label>Nombre Usuario</label>
              <input
                type="text"
                ref={refTxtNombre}
                className={`form-control form-control-sm mb-2 ${arrErrorEmpty.includes("DISPLAY_NAME") && "error"}`}
                defaultValue={userEdit?.DISPLAY_NAME}
              />
              <span className="text-danger">
                <strong>(*)</strong>
              </span>
              <label>Correo</label>
              <input
                className={`form-control form-control-sm mb-2 ${arrErrorEmpty.includes("EMAIL") && "error"}`}
                type=" mail"
                ref={refTxtCorreo}
                defaultValue={userEdit?.EMAIL}
                disabled={userEdit != null}
              />
              {(isEditPassword || !userEdit) && (
                <span className="text-danger">
                  <strong>(*)</strong>
                </span>
              )}
              <label>Contraseña</label>
              <input
                type="password"
                id="inputPassword1"
                data-testId="inputPassword1"
                className={`form-control form-control-sm mb-2 ${arrErrorEmpty.includes("CONTRASEÑA") && "error"}`}
                aria-describedby="passwordHelpBlock"
                ref={refTxtContraseña}
                minLength={8}
                onChange={(e) => {
                  setIsEditPassword(e.target.value.length > 0);
                }}
              />
              {(isEditPassword || !userEdit) && (
                <span className="text-danger">
                  <strong>(*)</strong>
                </span>
              )}

              <label>Confirmar contraseña</label>
              <input
                className={`form-control form-control-sm mb-2 ${
                  (arrErrorEmpty.includes("CONFIRMAR_CONTRASEÑA") || arrErrorEmpty.includes("CONTRASEÑA")) && "error"
                }`}
                type="password"
                id="inputPassword2"
                aria-describedby="passwordHelpBlock"
                ref={refTxtConfirmarContraseña}
                minLength={8}
              />
              <div className="my-4">
                <span className="text-danger">
                  <strong>(*)</strong>
                </span>
                <label>Activo</label>
                <span className={`${arrErrorEmpty.includes("ACTIVO") && "error"}`}>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="rdbUsuarioActivo"
                      id="inlineRadio1"
                      value="Sí"
                      onChange={(e) => {
                        setUserActivo(e.target.checked);
                      }}
                      defaultChecked={userEdit ? userEdit?.ACTIVO : true}
                    />
                    <label className="form-check-label" htmlFor="inlineRadio1">
                      Sí
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="rdbUsuarioActivo"
                      id="inlineRadio2"
                      value="No"
                      onChange={(e) => {
                        setUserActivo(!e.target.checked);
                      }}
                      defaultChecked={userEdit ? !userEdit?.ACTIVO : false}
                    />
                    <label className="form-check-label" htmlFor="inlineRadio2">
                      No
                    </label>
                  </div>
                </span>
              </div>

              {isLoading || (
                <section className="mt-5">
                  <button
                    type="button"
                    className="btn btn-primary btn-sm me-2"
                    data-bs-toggle="modal"
                    data-bs-target="#modalGuardar"
                    onClick={() => {
                      guardar();
                    }}>
                    Guardar
                  </button>
                  <button
                    type="button"
                    data-testid="btnvolver"
                    className="btn btn-secondary btn-sm"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                    onClick={() => {
                      onClose();
                    }}>
                    Volver
                  </button>
                </section>
              )}
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AgregarUsuarioExterno;
